// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#form-wrapper[data-v-1cfbec42]{display:flex}form[data-v-1cfbec42]{padding:20px;width:100%;background:#eee}", ""]);
// Exports
module.exports = exports;
